import React from 'react'
// libs
import moment from 'moment'
import { Field } from 'redux-form'
import { components } from 'react-select'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// types
import { Modals } from 'constants/modals'
import { IOption } from 'components/FormElements/Select'
import { Validators } from 'utils/validators'
import { WrappedFieldProps } from 'redux-form/lib/Field'
// views
import { Select } from 'components/FormElements'

interface Props {
  name: string
  label: string
  options: IOption[]
  validate?: Validators
}

const CustomMultiValue = (props) => {
  const { showModal: showSeyDatWorkingHoursModal } = useShowModal({ modalType: Modals.SET_DAY_WORKING_HOURS_MODAL })

  const handleClick = (event) => {
    event.stopPropagation()

    showSeyDatWorkingHoursModal({
      width: 'sm',
      key: props.data.value
    })
  }

  const onMouseDown = (event: React.MouseEvent) => event.stopPropagation()

  return (
    <div onClick={handleClick} onMouseDown={onMouseDown}>
      <components.MultiValueLabel {...props} />
    </div>
  )
}

const renderComponent = ({
  name,
  label,
  input,
  options,
  meta: { touched, error },
  ...rest
}: Props & WrappedFieldProps) => {
  const isError = touched && error

  const onChange = (value: IOption[]) => {
    input.onChange(
      value.map((option) => {
        if (!option.startTime) {
          return {
            ...option,
            startTime: moment().set({ hour: 9, minutes: 0 }),
            finishTime: moment().set({ hour: 18, minutes: 0 })
          }
        }

        return option
      })
    )
  }

  return (
    <Select
      {...rest}
      isMultiple
      error={error}
      isError={isError}
      options={options}
      name={input.name}
      value={input.value}
      handleChange={onChange}
      handleBlur={input.onBlur}
      handleFocus={input.onFocus}
      classNamePrefix={'react-select'}
      components={{ MultiValueLabel: CustomMultiValue }}
    />
  )
}

const ReduxBusinessDaysSelect: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxBusinessDaysSelect
